import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { getGroupDisplayName } from "@/lib/groupNameMapping";

interface TeamSelectorProps {
    teams: string[];
    selectedTeam: string;
    onTeamChange: (team: string) => void;
    disabled?: boolean;
    label?: string;
    id?: string;
}

const TeamSelector = ({ teams, selectedTeam, onTeamChange, disabled = false, label = "Team", id = "team" }: TeamSelectorProps) => {
    return (
        <div className="flex flex-col">
            <Label htmlFor={id}>{label}</Label>
            <Select value={selectedTeam} onValueChange={onTeamChange} disabled={disabled}>
                <SelectTrigger id={id} className="mt-1 w-full">
                    <SelectValue placeholder="Select a team" />
                </SelectTrigger>
                <SelectContent>
                    {teams.map(team => (
                        <SelectItem key={team} value={team}>
                            {getGroupDisplayName(team)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};

export default TeamSelector;
